// GENERATED FILE — do not edit. Source: contracts/permissions.yaml in sarva-ai-pms-backend.
// Regenerate there with `make codegen`; sync into this repo with `pnpm sync:contract`.

export const Permission = {
  PATIENT_READ: "patient:read",
  PATIENT_READ_PHI_SENSITIVE: "patient:read_phi_sensitive",
  PATIENT_WRITE: "patient:write",
  PATIENT_MERGE: "patient:merge",
  COVERAGE_READ: "coverage:read",
  COVERAGE_WRITE: "coverage:write",
  DOCUMENT_READ: "document:read",
  DOCUMENT_WRITE: "document:write",
  CONSENT_MANAGE: "consent:manage",
  CONSENT_FORM_EDIT: "consent_form:edit",
  NOTE_READ: "note:read",
  NOTE_WRITE: "note:write",
  NOTE_SIGN: "note:sign",
  NOTE_COSIGN: "note:cosign",
  NOTE_TEMPLATE_READ: "note_template:read",
  NOTE_TEMPLATE_EDIT: "note_template:edit",
  CARE_PLAN_READ: "care_plan:read",
  CARE_PLAN_WRITE: "care_plan:write",
  INTAKE_SEND: "intake:send",
  CHARGE_RULE_READ: "charge_rule:read",
  CHARGE_RULE_EDIT: "charge_rule:edit",
  SPECIALTY_PACK_INSTALL: "specialty_pack:install",
  APPOINTMENT_READ: "appointment:read",
  APPOINTMENT_WRITE: "appointment:write",
  APPOINTMENT_CANCEL: "appointment:cancel",
  SCHEDULE_MANAGE: "schedule:manage",
  WAITLIST_MANAGE: "waitlist:manage",
  SCHEDULE_TEMPLATE_READ: "schedule_template:read",
  SCHEDULE_TEMPLATE_WRITE: "schedule_template:write",
  ELIGIBILITY_READ: "eligibility:read",
  ELIGIBILITY_REQUEST: "eligibility:request",
  PRIOR_AUTH_READ: "prior_auth:read",
  PRIOR_AUTH_REQUEST: "prior_auth:request",
  PRIOR_AUTH_WRITE: "prior_auth:write",
  REFERRAL_READ: "referral:read",
  REFERRAL_WRITE: "referral:write",
  CHARGE_READ: "charge:read",
  CHARGE_WRITE: "charge:write",
  CHARGE_DELETE: "charge:delete",
  CHARGE_BATCH_RELEASE: "charge_batch:release",
  CODING_SUGGESTION_PROPOSE: "coding_suggestion:propose",
  CODING_SUGGESTION_READ: "coding_suggestion:read",
  CODING_SUGGESTION_ACCEPT: "coding_suggestion:accept",
  CODING_OVERRIDE_APPLY: "coding_override:apply",
  CLAIM_READ: "claim:read",
  CLAIM_WRITE: "claim:write",
  CLAIM_SUBMIT: "claim:submit",
  CLAIM_VALIDATE: "claim:validate",
  CLAIM_RESUBMIT: "claim:resubmit",
  CLAIM_VOID: "claim:void",
  WRITEBACK_TASK_READ: "writeback_task:read",
  WRITEBACK_TASK_COMPLETE: "writeback_task:complete",
  CLAIM_STATUS_READ: "claim_status:read",
  CLAIM_STATUS_REQUEST: "claim_status:request",
  SCRUB_RULE_READ: "scrub_rule:read",
  SCRUB_RULE_PROPOSE: "scrub_rule:propose",
  SCRUB_RULE_APPROVE: "scrub_rule:approve",
  REJECTION_READ: "rejection:read",
  REJECTION_DIAGNOSE: "rejection:diagnose",
  DENIAL_READ: "denial:read",
  DENIAL_CLASSIFY: "denial:classify",
  DENIAL_RESOLVE: "denial:resolve",
  APPEAL_READ: "appeal:read",
  APPEAL_DRAFT: "appeal:draft",
  APPEAL_SUBMIT: "appeal:submit",
  APPEAL_RECORD_OUTCOME: "appeal:record_outcome",
  REMITTANCE_READ: "remittance:read",
  REMITTANCE_INGEST: "remittance:ingest",
  PAYMENT_READ: "payment:read",
  PAYMENT_POST: "payment:post",
  PAYMENT_REVERSE: "payment:reverse",
  ADJUSTMENT_APPLY: "adjustment:apply",
  WRITE_OFF_APPLY: "write_off:apply",
  WRITE_OFF_APPROVE: "write_off:approve",
  REFUND_INITIATE: "refund:initiate",
  REFUND_APPROVE: "refund:approve",
  PATIENT_PAYMENT_TAKE: "patient_payment:take",
  STATEMENT_SEND: "statement:send",
  LEDGER_READ: "ledger:read",
  PERIOD_CLOSE: "period:close",
  IMPORT_READ: "import:read",
  IMPORT_STAGE: "import:stage",
  IMPORT_SIGN_OFF: "import:sign_off",
  IMPORT_COMMIT: "import:commit",
  WORK_ITEM_READ: "work_item:read",
  WORK_ITEM_ASSIGN: "work_item:assign",
  WORK_ITEM_RESOLVE: "work_item:resolve",
  FOLLOW_UP_NOTE_READ: "follow_up_note:read",
  FOLLOW_UP_NOTE_WRITE: "follow_up_note:write",
  OBLIGATION_READ: "obligation:read",
  OBLIGATION_RESOLVE: "obligation:resolve",
  AUTOMATION_READ: "automation:read",
  AUTOMATION_RUN: "automation:run",
  AUTOMATION_EDIT: "automation:edit",
  AUTOMATION_PUBLISH: "automation:publish",
  POLICY_BAND_READ: "policy_band:read",
  POLICY_BAND_EDIT: "policy_band:edit",
  AGENT_PAUSE: "agent:pause",
  PAYER_READ: "payer:read",
  PAYER_WRITE: "payer:write",
  LOCATION_READ: "location:read",
  LOCATION_WRITE: "location:write",
  FEE_SCHEDULE_READ: "fee_schedule:read",
  FEE_SCHEDULE_WRITE: "fee_schedule:write",
  CONTRACT_READ: "contract:read",
  CONTRACT_WRITE: "contract:write",
  PROVIDER_READ: "provider:read",
  PROVIDER_WRITE: "provider:write",
  ENROLLMENT_READ: "enrollment:read",
  ENROLLMENT_WRITE: "enrollment:write",
  CODE_SET_READ: "code_set:read",
  CODE_SET_WRITE: "code_set:write",
  CONNECTOR_READ: "connector:read",
  CONNECTOR_WRITE: "connector:write",
  CREDENTIAL_WRITE: "credential:write",
  CUSTOM_FIELD_MANAGE: "custom_field:manage",
  TENANT_SETTING_READ: "tenant_setting:read",
  TENANT_SETTING_EDIT: "tenant_setting:edit",
  FEATURE_FLAG_MANAGE: "feature_flag:manage",
  USER_READ: "user:read",
  USER_INVITE: "user:invite",
  USER_DEACTIVATE: "user:deactivate",
  MFA_ENROL: "mfa:enrol",
  MFA_RESET: "mfa:reset",
  ROLE_READ: "role:read",
  ROLE_ASSIGN: "role:assign",
  ROLE_DEFINE: "role:define",
  AUDIT_READ: "audit:read",
  PHI_ACCESS_LOG_READ: "phi_access_log:read",
  REPORT_READ: "report:read",
  REPORT_EXPORT: "report:export",
  SUPPORT_SESSION_START: "support_session:start",
  BREAK_GLASS_USE: "break_glass:use",
  INTEGRATION_VOICE_READ: "integration:voice_read",
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];

export const PHI_TIER: Record<Permission, string> = {
  "patient:read": "standard",
  "patient:read_phi_sensitive": "elevated",
  "patient:write": "standard",
  "patient:merge": "standard",
  "coverage:read": "standard",
  "coverage:write": "standard",
  "document:read": "restricted",
  "document:write": "restricted",
  "consent:manage": "standard",
  "consent_form:edit": "none",
  "note:read": "restricted",
  "note:write": "restricted",
  "note:sign": "restricted",
  "note:cosign": "restricted",
  "note_template:read": "none",
  "note_template:edit": "none",
  "care_plan:read": "restricted",
  "care_plan:write": "restricted",
  "intake:send": "standard",
  "charge_rule:read": "none",
  "charge_rule:edit": "none",
  "specialty_pack:install": "none",
  "appointment:read": "standard",
  "appointment:write": "standard",
  "appointment:cancel": "standard",
  "schedule:manage": "none",
  "waitlist:manage": "standard",
  "schedule_template:read": "none",
  "schedule_template:write": "none",
  "eligibility:read": "standard",
  "eligibility:request": "standard",
  "prior_auth:read": "standard",
  "prior_auth:request": "restricted",
  "prior_auth:write": "standard",
  "referral:read": "standard",
  "referral:write": "standard",
  "charge:read": "standard",
  "charge:write": "standard",
  "charge:delete": "standard",
  "charge_batch:release": "standard",
  "coding_suggestion:propose": "restricted",
  "coding_suggestion:read": "restricted",
  "coding_suggestion:accept": "restricted",
  "coding_override:apply": "restricted",
  "claim:read": "standard",
  "claim:write": "standard",
  "claim:submit": "standard",
  "claim:validate": "standard",
  "claim:resubmit": "standard",
  "claim:void": "standard",
  "writeback_task:read": "standard",
  "writeback_task:complete": "standard",
  "claim_status:read": "standard",
  "claim_status:request": "standard",
  "scrub_rule:read": "none",
  "scrub_rule:propose": "none",
  "scrub_rule:approve": "none",
  "rejection:read": "standard",
  "rejection:diagnose": "standard",
  "denial:read": "standard",
  "denial:classify": "restricted",
  "denial:resolve": "standard",
  "appeal:read": "standard",
  "appeal:draft": "restricted",
  "appeal:submit": "standard",
  "appeal:record_outcome": "standard",
  "remittance:read": "standard",
  "remittance:ingest": "standard",
  "payment:read": "standard",
  "payment:post": "standard",
  "payment:reverse": "standard",
  "adjustment:apply": "standard",
  "write_off:apply": "standard",
  "write_off:approve": "standard",
  "refund:initiate": "standard",
  "refund:approve": "standard",
  "patient_payment:take": "standard",
  "statement:send": "standard",
  "ledger:read": "standard",
  "period:close": "none",
  "import:read": "standard",
  "import:stage": "elevated",
  "import:sign_off": "none",
  "import:commit": "elevated",
  "work_item:read": "standard",
  "work_item:assign": "none",
  "work_item:resolve": "standard",
  "follow_up_note:read": "standard",
  "follow_up_note:write": "standard",
  "obligation:read": "standard",
  "obligation:resolve": "standard",
  "automation:read": "none",
  "automation:run": "standard",
  "automation:edit": "none",
  "automation:publish": "none",
  "policy_band:read": "none",
  "policy_band:edit": "none",
  "agent:pause": "none",
  "payer:read": "none",
  "payer:write": "none",
  "location:read": "none",
  "location:write": "none",
  "fee_schedule:read": "none",
  "fee_schedule:write": "none",
  "contract:read": "none",
  "contract:write": "none",
  "provider:read": "none",
  "provider:write": "none",
  "enrollment:read": "none",
  "enrollment:write": "none",
  "code_set:read": "none",
  "code_set:write": "none",
  "connector:read": "none",
  "connector:write": "none",
  "credential:write": "none",
  "custom_field:manage": "none",
  "tenant_setting:read": "none",
  "tenant_setting:edit": "none",
  "feature_flag:manage": "none",
  "user:read": "none",
  "user:invite": "none",
  "user:deactivate": "none",
  "mfa:enrol": "none",
  "mfa:reset": "none",
  "role:read": "none",
  "role:assign": "none",
  "role:define": "none",
  "audit:read": "standard",
  "phi_access_log:read": "elevated",
  "report:read": "standard",
  "report:export": "standard",
  "support_session:start": "none",
  "break_glass:use": "elevated",
  "integration:voice_read": "elevated",
};
